import React, { Component } from "react";
import { connect } from 'react-redux';
import OrgChart from '../../../../components/OrganizationSetup/OrgChart/OrgChart';
import * as actionCreators from './../../../../modules/actions/index';

class OrgChartSetup extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    // console.log(this.props);
    return (
      <div className="mb20 mt70">
        <OrgChart {...this.props}/>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    orgChart : state.orgChart
  }
}

const mapDispatchToProps = dispatch => {
	return {
    updateProfileInfoSuccess : (d) => dispatch(actionCreators.updateProfileInfoSuccess(d)),
		nextStep: () => dispatch(actionCreators.nextStep()),
    goBack : () => dispatch(actionCreators.goBack()),
    saveAllColumnsAndData : (c,d,f) => dispatch(actionCreators.saveAllColumnsAndData(c,d,f)),
    saveMatchedColumn: data => dispatch(actionCreators.saveOrgChartMatchedColumn(data)),
    saveOfficeHierarchy : (c) => dispatch(actionCreators.saveOfficeHierarchy(c)),
    saveAllOffices : (o) => dispatch(actionCreators.saveAllOffices(o)),
    saveAllOfficeMaterialPathsWithInvitation : (o) => dispatch(actionCreators.saveAllOfficeMaterialPathsWithInvitation(o)),
    flaggedAdminOfficeSelected : (o) => dispatch(actionCreators.flaggedAdminOfficeSelected(o)),
    saveAllOfficeMaterialPaths : (o) => dispatch(actionCreators.saveAllOfficeMaterialPaths(o))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(OrgChartSetup);